<button
	class="!ml-3" 
	mat-flat-button
	color="primary"
	(click)="openUploadContractDialog()"
	data-cy="upload-contract-btn">
	Upload Contract
</button>